import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { hourMinute } from '@showclix-shared-intl/dateTimeFormatters';
import { ISOStringToDate } from 'helpers/time';
import { getLowInventoryMessage, getSoldOutMessage, getEventTimeFormatted } from '../selectors/eventSeries';
import { TranslationContext } from '../../../../checkout/config/Translations';

class SeriesLineItem extends Component {
    render() {
        const time = ISOStringToDate(this.props.time);
        const timeString = hourMinute(this.props.locale, time);

        return (
            <TranslationContext.Consumer>
            {translation =>
            <label
                className={`card series-listing-item event__times--fade ${this.props.selected ? 'series-listing-item__selected' : ''} ${this.props.eventStatus === "sold_out" ? 'series-listing-item__sold-out' : ''}`}
            >
                {(this.props.eventStatus === "on_sale" || this.props.eventStatus === "pre_sale") &&
                    <input
                        type="radio"
                        className="series-listing-item__input"
                        onChange={this.onClick}
                        name={`series-listing-item_${this.props.label}`}
                        checked={this.props.selected}
                        aria-checked={this.props.selected}
                        autoFocus={this.props.autoFocus}
                    />
                }
                <div className="series-listing-item__inner">
                    <div className="series-listing-item__top">
                        <div className="series-listing-item__left">
                            <span className="series-line-item__radio-label">{this.props.getEventTimeFormatted(this.props.time, this.props.endTime)}</span>
                        </div>
                        <div className="series-listing-item__right">
                            {this.getStatusMessage(translation)}
                        </div>
                    </div>
                    <div className="series-listing-item__bottom">
                        <div className="series-listing-item__additional_info">
                            {this.props.seriesChildAdditionalInfo}
                        </div>
                    </div>
                </div>
            </label>
            }
            </TranslationContext.Consumer>
        )
    }

    getStatusMessage = translation => {
        if (this.props.eventStatus == 'pre_sale') {
            return <span className="sold-out__message">{translation.t('checkout__presale_only')}</span>
        } else if (this.props.eventStatus === "sold_out") {
            return <span className="sold-out__message">{this.props.getSoldOutMessage()}</span>;
        } else if(this.props.eventStatus === "post_sale") {
            return <span className="sold-out__message">{translation.t('checkout__online_sales_closed')}</span>;
        } else if(this.props.filtered) {
            return <span className="sold-out__message">{translation.t('checkout__not_available')}</span>;
        } else if(this.props.getLowInventoryMessage(this.props.eventInventory, translation)) {
            return <span className="low-inventory__message">{this.props.getLowInventoryMessage(this.props.eventInventory, translation)}</span>
        }
        return null;
    }

    onClick = () => {
        if(this.props.eventStatus !== "on_sale" && this.props.eventStatus !== "pre_sale") {
            return;
        }

        this.props.onClick(this.props.id, this.props.seriesChildAdditionalInfo);
    }
}

SeriesLineItem.propTypes = {
    onClick: PropTypes.func.isRequired,
    time: PropTypes.string.isRequired,
    id: PropTypes.PropTypes.oneOfType([PropTypes.string,PropTypes.number]).isRequired,
    selected: PropTypes.bool,
    eventStatus:PropTypes.string,
    showSoldOut:PropTypes.bool,
    eventInventory: PropTypes.number,
};

SeriesLineItem.defaultProps = {
    selected: false,
}

const mapStateToProps = (state) => {
    return {
        getLowInventoryMessage: getLowInventoryMessage(state),
        getSoldOutMessage: getSoldOutMessage(state),
        getEventTimeFormatted: getEventTimeFormatted(state),
    };
};

export default connect(mapStateToProps)(SeriesLineItem)
